export default {
    namespaced: true,

    state: {
        search: '',
        viewArchived: false,
    },

    getters: {
        searchQuery: state => state.search,
        hasQuery: state => state.search && state.search.length > 0,
    },

    actions: {},

    mutations: {
        SET_SEARCH(state, search) {
            state.search = search;
        },

        CLEAR_SEARCH(state) {
            state.search = '';
        },
    },
};
